// Whether the strip's cards fill the row at equal widths instead of
// scrolling: when a scroll would only reveal empty space.
//   - The row holds no more cards than fit whole (`wholeCards`, two beside
//     a phone): the peek's slice would be an empty gap.
//   - Every card's content, on its natural lines, fits an equal share of
//     the row: the cut card would hide only its own empty end.
// A fill that squeezed a card's content onto more lines ("3 members"
// wrapping) would be worse than a scroll, so the second test uses content
// widths measured without wrapping.

export type StripMeasure = {
  /** Each card's content width, unwrapped; Infinity for a card whose
   *  content isn't known yet (still loading), which never fits a share. */
  readonly contentWidths: readonly number[];
  /** The row's content width. */
  readonly rowWidth: number;
  /** The gap between cards. */
  readonly gap: number;
  /** How many cards the scrolling layout shows whole. */
  readonly wholeCards: number;
};

export function stripFills({ contentWidths, rowWidth, gap, wholeCards }: StripMeasure): boolean {
  const count = contentWidths.length;
  if (count <= wholeCards) return true;
  const share = (rowWidth - gap * (count - 1)) / count;
  return contentWidths.every((width) => width <= share);
}
